/* global translations */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import get from 'lodash/get';
import Slider from '../misc/Slider';
import MemberLink from '../member/MemberLink';
import MemberImage from '../member/MemberImage';
import MembersActionCreators from '../../actions/MembersActionCreators';
import MemberStore from '../../stores/MemberStore';

export default class SearchSlider extends Component {
  state = {
    currentMemberId: '',
    loading: true,
    members: [],
  };

  setCurrentMemberId = this.setCurrentMemberId.bind(this);

  componentDidMount() {
    MemberStore.addChangeListener(this.onChange);
    MembersActionCreators.loadLocalSearchedMembers();

    const memberIdRegex = /.*\/member\/([A-Z0-9]*)(\/.*)?/g;
    const memberIdMatches = memberIdRegex.exec(window.location.pathname);
    if (memberIdMatches && memberIdMatches[1]) {
      // eslint-disable-next-line
      // currentMemberId = memberIdMatches[1];
      this.setCurrentMemberId(memberIdMatches[1]);
    } else {
      MemberStore.removeSearchedMemberIds();
      ReactDOM.unmountComponentAtNode(document.getElementById('searchSlider'));
    }
  }

  componentWillUnmount() {
    MemberStore.setSearchedMembersPageNext(null);
    MemberStore.setSearchedMembersPagePrevious(null);
    MemberStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      loading: MemberStore.getLoading(),
      members: MemberStore.getAllSearched(),
    });
  };

  setCurrentMemberId(currentMemberId) {
    this.setState({
      currentMemberId,
    });
  }

  loadPreviousPage = (callback) => {
    let page = MemberStore.getSearchedMembersPagePrevious() || MemberStore.getSearchedMembersPage();
    const first = page === 1;
    if (!first) {
      // Temp empty members
      const { members } = this.state;
      for (let i = 0; i < 20; i += 1) {
        members.unshift({});
      }
      //
      const stateUpdate = { members };
      if (!this.state.loading) {
        MemberStore.setLoading(true);
        stateUpdate.loading = true;
      }
      this.setState(stateUpdate);
      //
      page -= 1;
      MemberStore.setSearchedMembersPagePrevious(page);
      MembersActionCreators.loadSearchedMembers(page, 'search', true);
    }
    if (callback) {
      callback(first);
    }
  };

  loadNextPage = (callback) => {
    // Temp empty members
    const { members } = this.state;
    for (let i = 0; i < 20; i += 1) {
      members.push({});
    }
    //
    const stateUpdate = { members };
    if (!this.state.loading) {
      MemberStore.setLoading(true);
      stateUpdate.loading = true;
    }
    this.setState(stateUpdate);
    //
    let page = MemberStore.getSearchedMembersPageNext() || MemberStore.getSearchedMembersPage();
    page += 1;
    MemberStore.setSearchedMembersPageNext(page);
    MembersActionCreators.loadSearchedMembers(page);
    if (callback) {
      callback();
    }
  };

  render() {
    const {
      members,
      loading,
      currentMemberId,
    } = this.state;

    const memberThumbs = [];
    let activeSlideIndex = null;
    members.forEach((item, index) => {
      // Temp empty members with loading
      if (!item._id) {
        if (loading) {
          const key = `temp_${index}`;
          memberThumbs.push([
            <div key={key} className="searchSlider-item has-loader" />,
          ]);
        }
        return;
      }
      //

      if (item._id === currentMemberId) {
        activeSlideIndex = index;
      }
      const nameAndAge = `${item.name} (${item.age})`;
      memberThumbs.push([
        <div key={item._id} className="searchSlider-item tooltip" data-tooltip={nameAndAge}>
          <MemberLink
            member={item}
            memberId={item._id}
          >
            <MemberImage
              member={item}
              memberId={item._id}
              type="s"
              hideIcons
              autosize
            />
          </MemberLink>
        </div>,
      ]);
    }, this);

    return (
      <div className="searchSlider">
        <Slider
          slideStyle={{ width: 80, height: 80 }}
          loadMoreCallback={this.loadNextPage}
          loadPreviousCallback={this.loadPreviousPage}
          title={get(translations, 'txt: Meklēšanas rezultāti', 'txt: Meklēšanas rezultāti')}
          offset={20}
          activeSlideIndex={activeSlideIndex}
          items={memberThumbs}
          loading={loading}
          setCurrentMemberId={this.setCurrentMemberId}
        />
      </div>
    );
  }
}
